export const CLASS_NAME = {
    ad: {
        inner: 'ad__inner',
        innerContainer: 'ad__inner__container',
        placeholder: 'ad__placeholder',
        placeholderInner: 'placeholder-inner'
    },
    carousel: {
        _: 'carousel',
        list: 'carousel-widget__list',
        button: 'carousel__button',
        next: 'carousel__button-next',
        prev: 'carousel__button-prev',
        sponsor: 'carousel__sponsor',
        sponsorLogo: 'carousel__sponsor-logo',
        btnVisible: 'carousel__button--visible',
        paginationList: 'carousel__pagination-list',
        paginationListItem: 'carousel__pagination-list-item',
        paginationListItemButton: 'carousel__pagination-list-button',
        paginationListItemActive: 'carousel__pagination-item--active'
    },
    carouselResource: {
        _: 'carousel-resource'
    },
    characterCount: {
        formFieldMessageCount: 'form-container__count',
        formFieldMessageCountError: 'form-container__count--error'
    },
    chatBot: {
        _: 'chat-bot'
    },
    common: {
        articleCard: 'article-card',
        button: 'button',
        buttonActive: 'button--active',
        buttonDisabled: 'button--disabled',
        buttonIcon: 'button--icon-only',
        buttonPrimary: 'button--primary',
        buttonPrimaryAlt: 'button--primary-alt',
        buttonText: 'button__text',
        buttonTransparent: 'button--transparent',
        hidden: 'hidden',
        visuallyHidden: 'visually-hidden',
        skipTo: 'skip-to',
        stickyHeader: 'sticky--header',
        formField: 'form-container__field',
        formFieldError: 'form-container__field--error',
        formFieldMessage: 'form-container__message',
        formFieldMessageError: 'form-container__message--error',
        formLabel: 'form__label',
        formControl: 'form__control',
        formCheckboxGroup: 'form-fieldset__checkbox-group-required',
        jsReplace: 'js-replace',
        scrollDisable: 'scroll-disabled'
    },
    comparisonResults: {
        buttonAction: 'comparison-results__action',
        buttonAddToMyPicks: 'comparison-results__action--add',
        buttonEditMyPicks: 'comparison-results__action--edit',
        buttonRemoveCard: 'result-card__remove',
        card: 'results-card',
        compareGrid: 'compare-grid',
        compareGridHeader: 'compare-grid__header',
        compareGridHeaderAdd: 'compare-grid__vehicle-slot--add',
        compareGridHeaderSticky: 'compare-grid__header--shrink',
        compareGridHeaderStickyFooterPush: 'compare-grid__header--footer-push',
        expansionPanelCustom: 'expansion-panel__custom',
        showOnCollapse: 'show-on-collapse',
        moreRatingButton: 'expansion-panel__more',
        lessRatingButton: 'expansion-panel__less',
        makeName: 'vehicle-card__brand',
        modelName: 'vehicle-card__model'
    },
    copyLink: {
        _: 'copy-link',
        isCopied: 'copy-link--copied',
        text: 'copy-link__text',
        icon: 'copy-link__icon'
    },
    featuredComparisons: {
        featuredComparisons: 'featured-comparisons',
        featuredComparisonsTabs: 'featured-comparisons__ul',
        tabNav: 'featured-comparisons__tab-nav'
    },
    drivingSubNav: {
        subNav: 'sub-nav',
        sticky: 'sub-nav__sticky',
        centerJustify: 'flex-justify-center',
        subNavOffset: 'sub-nav__offset'
    },
    dropdownChecklist: {
        open: 'dropdown-checklist--open'
    },
    findCompare: {
        advancedFiltersBtn: 'vehicle-finder__filter-btn',
        adSlot: 'ad__section-border--find-compare',
        buttonAddToCompare: 'find-card__action-add',
        buttonRemove: 'find-card__action-remove',
        card: 'find-card',
        cardSquare: 'find-card--square',
        cardAdded: 'find-card--added',
        cardContent: 'find-card__content',
        cardContentSquare: 'find-card__content--square',
        filtersBtn: 'filters-btn',
        list: 'vehicle-list',
        listBottom: 'vehicle-list__bottom',
        loading: 'loading',
        loadMore: 'load-more',
        loadMoreButton: 'load-more__button',
        makeName: 'find-card__brand',
        modelName: 'find-card__model'
    },
    gallery: {
        _: 'gallery',
        container: 'gallery-block',
        btn: 'gallery__button',
        fullscreenMod: '--toggle-fullscreen',
        fullscreenOpenMod: '--fullscreen-open',
        captionMod: '--toggle-caption',
        CaptionOpenMod: '--caption-open',
        thumbnailsMod: '--open-thumbnails',
        captionContainer: 'gallery__caption',
        captionVisMod: '--caption-visible'
    },
    header: {
        _: 'header',
        shrink: 'header--shrink',
        breaking: 'header-breaking__wrapper',
        offset: 'header--offset',
        sticky: 'sticky--header',
        subscribe: 'subscribe',
        menu: {
            _: 'header-menu-nav',
            opened: 'header-menu-nav--open',
            closed: 'header-menu-nav--closed',
            item: 'header-menu-nav__item',
            focusItem: 'header-menu-nav__focus-item',
            active: 'header-menu-nav--active'
        },
        mainMenu: {
            _: 'primary-nav',
            listOne: 'primary-nav__list-1',
            listTwo: 'primary-nav__list-2',
            noColumn: 'primary-nav__no-column-list-2',
            oneColumn: 'primary-nav__1column-list-2',
            twoColumn: 'primary-nav__2column-list-2',
            open: 'primary-nav--open',
            mobileDropMenu: 'primary-nav--drop',
            arrow: 'arrow-right',
            promotional: 'promotional',
            slogan: 'slogan',
            bundlMenu: 'hs-bundle-menu'
        },
        accountMenu: {
            _: 'account-nav',
            open: 'account-nav--open'
        },
        search: {
            _: 'site-search',
            form: 'site-search__form',
            hiddenButton: 'site-search__button--hidden',
            hiddenForm: 'site-search__form--hidden',
            inputId: 'id_search_text',
            submit: 'site-search__form-submit',
            toggle: 'site-search__button'
        },
        searchMobile: {
            input: 'js-site-search-input'
        },
        scroll: {
            shrink: 'header--shrink'
        }
    },
    footer: {
        _: 'footer'
    },
    hideOnOverlapComponent: {
        fadeIn: 'fade-in',
        fadeOut: 'fade-out'
    },
    imageService: {
        lazyload: 'lazyload',
        lazyloaded: 'lazyloaded'
    },
    list: {
        contentFeatured: 'feed-section__content-featured',
        contentMinimized: 'feed-section__content-minimized',
        contentSubheading: 'feed-section__content-subheading',
        contentCol: 'feed-section__content-col',
        listLoading: 'list--loading',
        listWidget: 'list-widget',
        listWidgetContentUnavailable: 'list-widget__content-unavailable',
        carouselWidget: 'carousel-widget'
    },
    mediaQuery: {
        hidden: 'hidden',
        hiddenExtraSmallUp: 'hidden-extra-small-do',
        hiddenSmallerUp: 'hidden-smaller-up',
        hiddenSmallUp: 'hidden-small-up',
        hiddenMediumUp: 'hidden-medium-up',
        hiddenLargeUp: 'hidden-large-up',
        hiddenExtraSmallDown: 'hidden-extra-small-down',
        hiddenSmallerDown: 'hidden-smaller-down',
        hiddenSmallDown: 'hidden-small-down',
        hiddenMediumDown: 'hidden-medium-down',
        hiddenLargeDown: 'hidden-large-down',
        hiddenSmallerOnly: 'hidden-smaller-only',
        hiddenSmallOnly: 'hidden-small-only',
        hiddenMediumOnly: 'hidden-medium-only',
        hiddenLargeOnly: 'hidden-large-only'
    },
    modal: {
        _: 'modal',
        open: 'modal--open',
        closed: 'modal--closed',
        closeBtn: 'modal__close',
        activated: 'modal--activated',
        backdrop: 'modal--backdrop',
        title: 'modal__title'
    },
    myPicks: {
        buttonEdit: 'my-picks__button--edit',
        buttonContinue: 'my-picks__button--continue',
        buttonLimitExceededModal: 'limit-exceeded__modal-edit-button',
        buttonRemoveIcon: 'my-picks__card__remove',
        buttonRemoveText: 'my-picks__card__remove-text',
        buttonFindMore: 'my-picks__button--find-more',
        buttonCompareNow: 'my-picks__button--compare-now',
        card: 'my-picks__card',
        cardAdded: 'my-picks__card--added',
        cardImage: 'my-picks__card__image',
        cardName: 'my-picks__card__name',
        cardTrim: 'my-picks__card__trim',
        expandButton: 'my-picks__button--expand',
        expanded: 'my-picks__expanded',
        expandedShow: 'my-picks__expanded--show',
        expandedHide: 'my-picks__expanded--hide',
        expandedTitle: 'my-picks__header__title',
        information: 'my-picks__information',
        informationEmpty: 'my-picks__empty',
        loading: 'my-picks__loading',
        numVehicles: 'my-picks__number-vehicle',
        selections: 'my-picks__selections',
        shrink: 'my-picks__shrink-controls',
        shrinkButton: 'my-picks__button--shrink',
        sponsored: 'my-picks__sponsored',
        sponsoredCard: 'my-picks__sponsored__card',
        sponsoredCardHref: 'my-picks__href'
    },
    newsletter: {
        replaceEl: 'js-replace-main',
        form: 'js-newsletter-form',
        formSubmitError: 'js-submit-error',
        formSubmitSuccess: 'js-submit-success',
        subscribeMessage: 'js-subscribe-message',
        unsubscribeMessage: 'js-unsubscribe-message',
        email: 'js-newsletter-email',
        emailText: 'js-newsletter-email-text',
        emailField: 'js-newsletter-email__field',
        emailFieldError: 'form-container__field--error',
        emailError: 'js-invalid-email',
        captchaError: 'js-invalid-captcha',
        card: 'newsletter-card',
        cardChecked: 'newsletter-card--checked',
        cardSuccess: 'newsletter-card--success',
        cardSuccessMessage: 'newsletter-card__success-message',
        cardUnsubscribeButton: 'newsletter-card__unsubscribe',
        authorNameInput: 'js-newsletter-author-name'
    },
    priceline: {
        hidden: 'priceline-widget__display-none',
        loading: 'priceline-widget__loading'
    },
    page: {
        comparisonResults: 'page-comparison-results',
        findCompare: 'page-find-compare'
    },
    popover: {
        _: 'popover',
        event: 'popover__event',
        trigger: 'popover__trigger',
        content: 'popover__content',
        close: 'popover__content__close',
        tail: 'popover__content__tail'
    },
    readMore: {
        _: 'read-more',
        readMoreBtn: 'read-more__show',
        readLessBtn: 'read-more__hide',
        halfContent: 'read-more__content--half',
        fullContent: 'read-more__content--full'
    },
    recaptcha: {
        _: 'g-recaptcha'
    },
    search: {
        formAdvanced: 'search-form--advanced',
        dateRange: 'date-range-select',
        sort: 'sort-select'
    },
    shareButton: {
        _: 'share-button',
        wrapper: 'share-button__wrapper',
        isVisible: 'share-button--visible',
        modal: 'share-button__modal',
        modalArrow: 'share-button__modal-arrow',
        modalIsOpen: 'share-button__modal--open',
        modalClose: 'share-button__modal-close',
        modalTitle: 'share-button__modal-article-title',
        modalItem: 'share-button__modal-item',
        modalItemLink: 'share-button__modal-item-link',
        modalItemText: 'share-button__modal-item-text'
    },
    slider: {
        active: 'slider--active'
    },
    slidingDrawer: {
        _: 'sliding-drawer',
        backdropSupport: 'scroll-disabled',
        backdropEl: 'sliding-drawer__backdrop',
        close: 'sliding-drawer__close',
        slideUp: 'sliding-drawer--slide-in',
        slideDown: 'sliding-drawer--slide-out'
    },
    trimSelector: {
        button: 'trim-selector__footer__button',
        buttonNoMorePickModal: 'no-more-pick__modal-ok-button',
        image: 'trim-selector__info__image',
        imageModal: 'trim-selector__modal-image',
        make: 'trim-selector__info__make',
        model: 'trim-selector__info__model',
        noMorePickModal: 'no-more-pick__modal',
        wrapper: 'trim-selector__trims',
        vehicleIcon: 'trim-selector__my-pick',
        vehicleMyPick: 'trim-selector__my-pick--my-pick',
        vehicleChecked: 'trim-selector__my-pick--checked',
        myPicksWrapper: 'trim-selector__my-picks__wrapper'
    },
    modelPage: {
        _: 'page-model',
        trimSelectorForm: 'model__trim',
        trimSelect: 'model__trim-select'
    },
    brandPage: {
        _: 'page-brand',
        adSlot: 'ad__section-border--brand',
        loadMoreButton: 'load-more__button',
        vehicleListGroup: 'vehicle-list-group',
        overviewText: 'read-more__content--full',
        latestNews: 'latest-news__grid'
    },
    sellYourCar: {
        _: 'sell-your-car',
        wrapper: 'clutch-sell-your-car__wrapper',
        externalWrapper: 'clutch-sell-your-car__external-wrapper',
        elementToReplace: 'driving-element-to-replace',
        sellYourCarForm: 'form-sell-your-car',
        plateNumber: 'input__plate',
        postalCode: 'input__postal-code'
    },
    financingTool: {
        _: 'financing-tool',
        wrapper: 'clutch-financing-tool__wrapper',
        externalWrapper: 'clutch-financing-tool__external-wrapper'
    },
    shoppingTools: {
        _: 'shopping-tools',
        wrapper: 'clutch-shopping-tools__wrapper',
        externalWrapper: 'clutch-shopping-tools__external-wrapper'
    },
    inventoryListing: {
        _: 'inventory-listing',
        inventoryWrapper: 'clutch-vehicle-inventory__wrapper',
        inventoryNavButton: 'clutch-vehicle-inventory__nav-button'
    },
    topVehiclesPage: {
        _: 'page-top-vehicles',
        adSlot: 'ad__section-border--top-vehicles',
        cardAdded: 'find-card--added',
        vehicleList: 'vehicle-list',
        loadMoreButton: 'load-more__button',
        listBottom: 'vehicle-list__bottom',
        loading: 'loading',
        loadMore: 'load-more',
        makeName: 'find-card__brand',
        modelName: 'find-card__model'
    },
    vehicleDualComparisonPage: {
        _: 'page-vehicle-dual-comparison'
    },
    vehicleTrimComparisonPage: {
        _: 'page-vehicle-trim-comparison'
    },
    vehicleFinder: {
        _: 'vehicle-finder',
        desktopToggle: 'vehicle-finder__toggle--desktop',
        mobileToggle: 'vehicle-finder__toggle--mobile',
        filterToggle: 'vehicle-finder__filter-btn',
        form: 'form-container',
        makeButton: 'vehicle-finder__make-dropdown-control',
        makeFieldset: 'vehicle-finder__fieldset--make',
        modelButton: 'vehicle-finder__model-dropdown-control',
        modelFieldset: 'vehicle-finder__fieldset--model',
        bodystylesFieldset: 'vehicle-finder__fieldset--bodystyles',
        minPriceFieldset: 'vehicle-finder__min-price',
        maxPriceFieldset: 'vehicle-finder__max-price',
        seatsFieldset: 'advanced-filter__fieldset--seats',
        yearsFieldset: 'advanced-filter__fieldset--year',
        transmissionsFieldset: 'advanced-filter__fieldset--transmission',
        advancedFormSection: 'advanced-filter',
        powerSourcesFieldset: 'advanced-filter__fieldset--power_source',
        wrapper: 'vehicle-finder__container'
    },
    videoPlaylist: {
        _: 'video-playlist',
        queue: 'video-playlist__queue',
        carousel: 'video-playlist__carousel',
        chevronLeft: 'video-playlist__carousel-chevron--left',
        chevronRight: 'video-playlist__carousel-chevron--right',
        hr: 'video-playlist__divider--queue',
        item: 'video-playlist__queue-item',
        itemBtn: 'video-playlist__queue-item-btn',
        itemImg: 'video-playlist__queue-item-img',
        itemImgYT: 'video-playlist__queue-item-img--yt',
        itemImgOverlay: 'video-playlist__queue-item-img-overlay',
        itemContent: 'video-playlist__queue-item-content',
        itemTitle: 'video-playlist__queue-item-title',
        meta: 'video-playlist__meta',
        metaPubtime: 'video-playlist__meta-pub-date',
        metaDuration: 'video-playlist__meta-duration',
        metaDescription: 'video-playlist__meta-description',
        metaDescriptionVisibleLines: 'video-playlist__meta-description-clamp',
        nowPlaying: 'video-playlist__queue-item--now-playing',
        numVideos: 'video-playlist__num-videos',
        title: 'video-playlist__queue-title',
        leadvideo: {
            _: 'lead-video',
            bg: 'lead-video__player-bg',
            iframe: 'lead-video__iframe',
            title: 'lead-video__title',
            sectionTitle: 'video-playlist__title',
            jwInjection: 'jw-injection',
            jwWrapper: 'lead-video__jw-wrapper',
            wrapper: 'video-playlist__lead-wrapper',
            heroList: 'hero-feed__wrapper',
            moreVideo: 'more-stories',
            readMore: 'read-more'
        },
        videoCentre: {
            _: 'video-centre',
            title: 'video-centre__title'
        }
    },
    weather: {
        last: 'more-stories--weather-widget'
    }
}
